"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _curry = _interopRequireDefault(require("curry"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _isString = _interopRequireDefault(require("lodash/isString"));
const filter = (0, _curry.default)((fn, data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data.filter(fn);
  if ((0, _isObject.default)(data)) {
    const retData = {};
    for (let key in data) {
      if (fn(data[key], key, data)) {
        retData[key] = data[key];
      }
    }
    return retData;
  }
  if ((0, _isString.default)(data)) {
    return data.split('').filter(fn).join('');
  }
  return [];
});
var _default = exports.default = filter;